import _ from 'lodash'

export const useTnaflix = () => {
	const {getFileNameFromUrl, extFetch} = useHelpers()
	/**
	 * Extract video URL from tnaflix page
	 */
	async function getVideoFromUrl(url) {
		console.log('[useTnaflix] Processing URL:', url);
		try {
			// If it's already a direct video URL, return it
			if (url.match(/\.(mp4|webm|m3u8?)(\?|$)/i)) {
				let isHLS = !!url.match(/\.m3u8?(\?|$)/i)
				console.log('[useTnaflix] Direct URL detected. isHLS:', isHLS);
				let fileName = getFileNameFromUrl(url) || 'video.mp4'
				
				return {
					website: 'tnaflix.com',
					type: 'video',
					url: url,
					fileName: fileName,
					headers: {
						'Referer': 'https://www.tnaflix.com/',
						'Origin': 'https://www.tnaflix.com'
					},
					previewUrl: url,
					thumbnail: null,
					canView: true,
					hls: isHLS
				}
			}

			// Otherwise, try to fetch the page and extract video URL
			try {
				let response = await extFetch(url, {
					method: 'GET',
					headers: {
						'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36',
						'Referer': 'https://www.tnaflix.com/'
					}
				})

				if (response && response.body) {
					let html = typeof response.body === 'string' ? response.body : (response.body.toString ? response.body.toString() : String(response.body))
					
					// Extract video sources
					const sources = [];
					const sourceRegex = /<source\s+src="([^"]+)"\s+type="video\/mp4"\s+size="(\d+)">/g;
					let match;
					while ((match = sourceRegex.exec(html)) !== null) {
						sources.push({
							url: match[1].replace(/&amp;/g, '&'),
							quality: parseInt(match[2])
						});
					}

					console.log('[useTnaflix] Found sources:', sources.length);

					if (sources && sources.length > 0) {
						// Sort by quality descending
						sources.sort((a, b) => b.quality - a.quality);
						const bestSource = sources[0];
						
						console.log(`[useTnaflix] Selected source: ${bestSource.quality}p`);

						const videoIdMatch = url.match(/video(\d+)/);
						const videoId = videoIdMatch ? videoIdMatch[1] : 'video';
						const fileName = `${videoId}_${bestSource.quality}p.mp4`;
						
						return {
							website: 'tnaflix.com',
							type: 'video',
							url: bestSource.url,
							fileName: fileName,
							headers: {
								'Referer': url,
								'Origin': 'https://www.tnaflix.com'
							},
							previewUrl: bestSource.url,
							thumbnail: null,
							canView: true,
							quality: bestSource.quality + 'p',
							hls: false
						}
					}
				}
			} catch (fetchError) {
				console.warn('[useTnaflix] Could not fetch page to extract video URL:', fetchError)
			}

			// Fallback
			return {
				website: 'tnaflix.com',
				type: 'video',
				url: url,
				fileName: 'video.mp4',
				previewUrl: url,
				thumbnail: null,
				canView: true
			}
		} catch (error) {
			console.error('Error fetching video from URL:', error)
			return {
				website: 'tnaflix.com',
				type: 'video',
				url: url,
				fileName: 'video.mp4',
				previewUrl: url,
				thumbnail: null,
				canView: true
			}
		}
	}

	/**
	 * Process multiple URLs and extract videos
	 */
	async function getVideosFromUrls(urls) {
		let validUrls = urls
			.split('\n')
			.map(url => url.trim())
			.filter(url => url && url.length > 0)

		let results = await Promise.all(
			validUrls.map(url => getVideoFromUrl(url))
		)

		return results.map((media, index) => ({
			...media,
			id: `tnaflix-${Date.now()}-${index}`,
			source: 'tnaflix'
		}))
	}

	return {
		getMedia: async (form) => {
			if (form.urls) return getVideosFromUrls(form.urls)
			if (form.url) {
				let media = await getVideoFromUrl(form.url)
				media.id = `tnaflix-${Date.now()}`
				media.source = 'tnaflix'
				return [media]
			}
			return []
		},
		getVideoFromUrl,
		getVideosFromUrls
	}
}
